export default {
    height: "auto",
    calcHeight: 30,
    tip: false,
    searchShow: true,
    searchSpan: 5,
    searchMenuSpan: 4,
    border: true,
    index: false,
    viewBtn: false,
    delBtn: false,
    addBtn: false,
    editBtn: false,
    selection: true,
    dialogClickModal: false,
    searchLabelWidth: 100,
    column: [{
            label: "",
            prop: "id",
            type: "input",
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            hide: true,
        },
        {
            label: "租赁人",
            prop: "name",
            type: "input",
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            search: true,
        },
        {
            label: "手机号",
            prop: "phoneNumber",
            type: "input",
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            search: true,
        },
        {
            label: "租赁金额",
            prop: "lendingAmount",
            type: "input",
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
        },
        {
            label: "还款日",
            prop: "repaymentDate",
            type: "input",
            slot: "true",
            width: 160,
        },
        {
            label: "每月租金",
            prop: "lendingAmountPer",
            type: "input",
            slot: true,
        },
        {
            label: "当前期数",
            prop: "currentTenancy",
            type: "input",
            slot: true,
        },
        {
            label: "状态",
            prop: "status",
            type: "select",
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            dicData: [{
                    label: "待还款",
                    value: 1,
                },
                {
                    label: "还款完成",
                    value: 2,
                },
                {
                    label: "部分还款",
                    value: 3,
                },
                {
                    label: "逾期还清",
                    value: 4,
                },
            ],
        },
        {
            label: "所属代理商",
            prop: "businessDeptName",
            type: "input",
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
        },
        {
            label: "所属代理商",
            prop: "businessDeptId",
            type: "tree",
            filterable: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            search: true,
            searchClearable: false,
            searchOrder: 2,
            hide: true,
            dicData: [],
            props: {
                label: "title",
            },
        },
    ],
};
